import { isBoolean } from 'lodash'
import { defineObject } from '@/lib/define/use-define'
import { handleSortQualificationArray } from '@/lib/staff/utils'
import {
  handleChangeKeyCamelSet,
  handleSortStaffData,
} from '@/lib/list/staff-list-sort'
import { getKindOfRequest, getIsAbsence2 } from '@/lib/attendance/utils'

const katakanaToHiragana = (src: string) => {
  return src.replace(/[\u30a1-\u30f6]/g, (match: string) => {
    const chr = match.charCodeAt(0) - 0x60
    return String.fromCharCode(chr)
  })
}

const sortFunc = (firstElement: any, secondElement: any) => {
  const firstLastKana = katakanaToHiragana(firstElement.last_kana.toString())
  const secondLastKana = katakanaToHiragana(secondElement.last_kana.toString())
  if (firstLastKana < secondLastKana) return -1
  else if (firstLastKana > secondLastKana) return 1
  return 0
}

export const calculationOfUsageTime = (
  comeTimeHour: any,
  comeTimeMinute: any,
  returnTimeHour: any,
  returnTimeMinute: any
) => {
  const endTime = new Date(1990, 1, 1, returnTimeHour, returnTimeMinute)
  const startTime = new Date(1990, 1, 1, comeTimeHour, comeTimeMinute)
  const diff = endTime.getTime() - startTime.getTime()
  const diffMinute = Math.floor(diff / (1000 * 60))
  return diffMinute
}

export const fromNumberToString = <T, K extends keyof T>(
  element: T,
  oldKey: K,
  newKey: K,
  array: K[]
) => {
  // K extends keyof T
  // KはTを継承しておりかつkeyofによってelementの中のプロパティだと明示している
  const cuurentIndex = element[oldKey]
  // T[K]型にK[]型の値は入れられないためK[]型を一度unknown型に変換してからT[K]型にしている
  element[newKey] = (array[Number(cuurentIndex)] as unknown) as T[K]
}

export const fromBooleanToString = <T, K extends keyof T>(
  element: T,
  oldKey: K,
  newKey: K
) => {
  if (element[oldKey]) {
    element[newKey] = ('できる' as unknown) as T[K]
  } else {
    element[newKey] = ('できない' as unknown) as T[K]
  }
}

// export const fromArrayToString = () => {

// }

export const sortKana = <T>(array: T[]): T[] => {
  array.sort(sortFunc)
  return array
}

export const createMinArray = () => {
  // minArray = []
  const minArray: string[] = []
  for (let i = 0; i < 60; i++) {
    const min = ('0' + i).slice(-2)
    minArray.push(min)
  }
  return minArray
}

export const pickupLatlng = (
  latlngElement: any,
  name: string,
  pickupLatlngElement: any,
  schoolLatlng: any,
  otherLatlng: any
) => {
  Object.keys(latlngElement).forEach(key => {
    if (name === '学校') {
      pickupLatlngElement[key] = schoolLatlng[key]
    } else if (name === '自宅') {
      pickupLatlngElement[key] = latlngElement[key]
    } else if (name === 'その他') {
      pickupLatlngElement[key] = otherLatlng[key]
    }
  })
}

export const creationDate = (
  number: number,
  currentYear: number,
  currentMonth: number,
  currentDay: number
) => {
  const dateArray = []
  for (let i = 0; i <= number; i++) {
    const selectDate = new Date(`${currentYear}/${currentMonth}/${currentDay}`)
    selectDate.setDate(selectDate.getDate() + i)
    const weekNumber = selectDate.getDay() as number
    let weekday
    if (weekNumber === 0) {
      weekday = 'sunday'
    } else if (weekNumber === 6) {
      weekday = 'saturday'
    } else {
      weekday = 'weekday'
    }
    dateArray.push({
      year: selectDate.getFullYear(),
      month: selectDate.getMonth() + 1,
      day: selectDate.getDate(),
      weekNumber: weekNumber,
      weekday: weekday,
    })
  }
  return dateArray
}

export const confirmParentCheckData = (
  allChildArray: any[],
  atChildAllArray: any[]
) => {
  if (allChildArray.length !== 0) {
    allChildArray.forEach(child => {
      child.checkFlg = false
      const atCldArray = atChildAllArray.filter(
        atData => child.id === atData.cld_id
      )
      if (atCldArray.length !== 0) {
        const result = atCldArray.some(data => data.check_flg === '1')
        if (result) {
          child.checkFlg = true
        }
      }
    })
  }
  return allChildArray
}

export const atNewCldCreationData = (
  appearDay: number,
  currentYear: number,
  currentMonth: number,
  currentDay: number,
  allChildArray: any[],
  atChildAllArray: any[]
) => {
  const afterSortAtChildArray = [] as any[]
  const dateArray = creationDate(
    appearDay,
    currentYear,
    currentMonth,
    currentDay
  )
  const today = new Date()
  allChildArray.forEach(child => {
    if (!('setting_pick_flg' in child) || child.setting_pick_flg === '') {
      child['setting_pick_flg'] = 0
    }
    const atDataArray = [] as any[]
    dateArray.forEach((date: any) => {
      const currentWeek = defineObject.FORMULA_WEEK_ARRAY[date.weekNumber]
      const object = {
        cldId: child.id,
        lastName: child.last_name,
        firstName: child.first_name,
        flg: 9,
        year: date.year,
        month: date.month,
        day: date.day,
        yearClass: `year_${date.year}`,
        monthClass: `${date.day}`,
        dayClass: date.weekday,
        week: currentWeek,
        weekNumber: date.weekNumber,
        isNew: '',
      }
      atDataArray.push(object)
    })
    const filterChildArray = atChildAllArray.filter((el: any) => {
      return child.id === el.cld_id
    })
    atDataArray.forEach((date: any, index: number) => {
      filterChildArray.forEach(atCldData => {
        if (
          atCldData.year === date.year &&
          atCldData.month === date.month &&
          atCldData.day === date.day
        ) {
          atCldData.week = date.week
          if (atCldData.come_time_hour !== '') {
            if (getIsAbsence2(atCldData)) {
              atCldData.isAbsence2 = true
            } else {
              atCldData.isAbsence2 = false
            }
          }

          const targetDate = new Date(
            atCldData.year,
            atCldData.month - 1,
            atCldData.day
          )
          const todayDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
          )
          if (targetDate.getTime() >= todayDate.getTime()) {
            atCldData.cldId = atCldData['cld_id']

            if (
              !('pickPlansFlg' in atCldData) &&
              atCldData.pick_plans_flg === ''
            ) {
              atCldData.pickPlansFlg = Number(child.setting_pick_flg)
              delete atCldData.pick_plans_flg
            } else if (
              atCldData.pick_plans_flg !== '' &&
              atCldData.pick_plans_flg !== undefined
            ) {
              atCldData.pickPlansFlg = atCldData.pick_plans_flg
            }

            if (
              !('sendPlansFlg' in atCldData) &&
              atCldData.send_plans_flg === ''
            ) {
              atCldData.sendPlansFlg = Number(child.setting_send_flg)
              delete atCldData.send_plans_flg
            } else if (
              atCldData.send_plans_flg !== '' &&
              atCldData.send_plans_flg !== undefined
            ) {
              atCldData.sendPlansFlg = atCldData.send_plans_flg
            }

            if (
              atCldData.flg === 3 ||
              atCldData.flg === 4 ||
              atCldData.flg === 5
            ) {
              // 過去は除く
              atCldData.isRequest = true
            } else if (atCldData.flg === 1) {
              const requestType = getKindOfRequest(atCldData)
              if (requestType === 'reschedule') {
                atCldData.isRequest = true
              }
            }
          } else {
            if (
              atCldData.flg === 1 &&
              atCldData.come_time_hour === '' &&
              atCldData.come_time_minute === ''
            ) {
              atCldData.flg = 9
            }
            atCldData.pickPlansFlg = atCldData.pick_plans_flg
            atCldData.sendPlansFlg = atCldData.send_plans_flg
          }
          atDataArray.splice(index, 1, atCldData)
        }
      })
    })

    let backgroundClass = ''
    if (child.active === 0) {
      backgroundClass = 'none'
    }
    afterSortAtChildArray.push({
      cldId: child.id,
      backgroundClass: backgroundClass,
      data: atDataArray,
    })
  })
  return afterSortAtChildArray
}

export const atCldCreationData = (
  appearDay: number,
  currentYear: number,
  currentMonth: number,
  currentDay: number,
  allChildArray: any[],
  atChildAllArray: any[],
  atStaffAllArray: any[],
  state: any
) => {
  const afterSortAtChildArray = [] as any[]
  const totalAttendanceArray = [] as any
  const totalAbsenceArray = [] as any
  const totalHolidayArray = [] as any
  const totalAbsence2Array = [] as any
  const dailyStaffArray = [] as any
  let shiftManagementFlg = false

  const dateArray = creationDate(
    appearDay,
    currentYear,
    currentMonth,
    currentDay
  )
  dateArray.forEach((date: any) => {
    const totalDataArray = {
      year: date.year,
      month: date.month,
      day: date.day,
      attendance: 0,
      holiday: 0,
      absence: 0,
      absence2: 0,
      staffArray: [],
    } as any

    allChildArray.forEach((child: any) => {
      atChildAllArray.forEach((el: any) => {
        if (child.id === el.cld_id) {
          if (
            el.year === date.year &&
            el.month === date.month &&
            el.day === date.day
          ) {
            if (el.come_time_hour !== '') {
              if (getIsAbsence2(el)) {
                el.isAbsence2 = true
              } else {
                el.isAbsence2 = false
              }
            }
            if (el.flg === 1 && !el.isAbsence2) {
              if (el.come_time_hour !== '') {
                totalDataArray.attendance++
              }
            }
            if (el.flg === 1 && el.isAbsence2) {
              if (el.come_time_hour !== '') {
                totalDataArray.absence2++
              }
            }
            if (el.flg === 0) {
              totalDataArray.absence++
            }
            if (el.flg === 2) {
              totalDataArray.holiday++
            }
          }
        }
      })
    })

    totalAttendanceArray.push(totalDataArray.attendance)
    totalAbsenceArray.push(totalDataArray.absence)
    totalHolidayArray.push(totalDataArray.holiday)
    totalAbsence2Array.push(totalDataArray.absence2)

    atStaffAllArray.forEach((data: any) => {
      const atStaffYear = Object.keys(data)[0].split('-')[0]
      const atStaffMonth = Object.keys(data)[0].split('-')[1]
      const atStaffDay = Object.keys(data)[0].split('-')[2]

      if (
        Number(atStaffYear) === date.year &&
        Number(atStaffMonth) === date.month &&
        Number(atStaffDay) === date.day
      ) {
        let attendanceStaffArray = data[Object.keys(data)[0]].filter(
          (staff: any) =>
            staff.flg === '1' && staff.shift_management_flg === '2'
        )

        if (attendanceStaffArray.length !== 0) {
          attendanceStaffArray.forEach((atStaff: any) => {
            const staffInfo = state.staffInfoArray.find(
              (staffInfo: any) => staffInfo.staff_id === atStaff.staff_id
            )

            if (staffInfo) {
              if (Array.isArray(staffInfo.qualification)) {
                const qualificationArray: {
                  [key: string]: string
                }[] = []
                staffInfo.qualification.some((qualificationId: string) => {
                  const qualificationData = state.qualificationArray.find(
                    (qualification: { [key: string]: string }) =>
                      qualification.id === qualificationId
                  )
                  if (!qualificationData) return true
                  qualificationArray.push(qualificationData)
                })
                atStaff.qualificationArray = []
                atStaff.qualificationArray.push(
                  ...handleSortQualificationArray(qualificationArray)
                )
              }

              atStaff.employeeType = staffInfo.employee_type
              atStaff.active = staffInfo.active
            }
          })

          attendanceStaffArray = handleChangeKeyCamelSet(attendanceStaffArray)

          attendanceStaffArray = handleSortStaffData(attendanceStaffArray)
        }

        totalDataArray.staffArray.push(...attendanceStaffArray)
      }
    })

    if (!shiftManagementFlg && totalDataArray.staffArray.length !== 0) {
      shiftManagementFlg = true
    }

    dailyStaffArray.push(totalDataArray.staffArray)
  })

  afterSortAtChildArray.push({
    attendance: totalAttendanceArray,
    absence: totalAbsenceArray,
    holiday: totalHolidayArray,
    absence2: totalAbsence2Array,
    dailyStaff: dailyStaffArray,
  })

  state.shiftManagementFlg = shiftManagementFlg

  return afterSortAtChildArray
}

export const diffDate = (fromDate: string, toDate: string) => {
  const from = new Date(fromDate)
  const fromTime = from.getTime()
  // 指定日時を数値に変換
  const to = new Date(toDate)
  const toTome = to.getTime()
  // 差
  const diffSec = toTome - fromTime
  const diffDays = diffSec / (1000 * 60 * 60 * 24)
  const showDays = Math.ceil(diffDays)
  return showDays
}

export const countChildData = (
  allChildArray: any[],
  atChildAllArray: any[]
) => {
  if (allChildArray.length !== 0) {
    allChildArray.forEach(child => {
      child.totalAttendance = 0
      child.totalAbsence = 0
      atChildAllArray.forEach(atChild => {
        atChild.isAbsence2 = false
        if (atChild.come_time_hour !== '') {
          if (getIsAbsence2(atChild)) {
            atChild.isAbsence2 = true
          } else {
            atChild.isAbsence2 = false
          }
        }
        if (child.id === atChild.cld_id || child.id === atChild.cldId) {
          if (atChild.flg === 1 && !atChild.isAbsence2) {
            child.totalAttendance++
          }
          if (atChild.flg === 0) {
            child.totalAbsence++
          }
        }
      })
    })
  }
  return allChildArray
}

export const countVisitChildData = (state: any) => {
  if (state.allHohouChildArray.length !== 0) {
    state.allHohouChildArray.forEach((child: any) => {
      child.totalVisitAttendance = 0
      child.totalVisitAbsence = 0
      state.atHohouChildAllArray.forEach((atChild: any) => {
        if (child.id === atChild.cld_id || child.id === atChild.cldId) {
          if (atChild.flg === 1) {
            child.totalVisitAttendance++
          }
          if (atChild.flg === 0) {
            child.totalVisitAbsence++
          }
        }
      })
    })
  }
  // return state.allHohouChildArray
}

export const totalCountAttendanceData = (
  allChildArray: any[],
  atChildAllArray: any[],
  monthDay: number
) => {
  const totalAttendance = {
    totalAttendance: 0,
    totalCancel: 0,
  }
  allChildArray.forEach((child: any) => {
    atChildAllArray.forEach(atChild => {
      if (child.id === atChild.cld_id || child.id === atChild.cldId) {
        if (atChild.flg === 1) {
          totalAttendance.totalAttendance++
        }
        if (atChild.flg === 0) {
          totalAttendance.totalCancel++
        }
      }
    })
  })
  return totalAttendance
}

export const schoolYearConvert = (allChildArray: any[]) => {
  allChildArray.forEach((child: any) => {
    if (child.school_year.indexOf('歳') !== -1) {
      child.schoolYear = child.school_year.substr(0, 1)
    } else if (child.school_year.indexOf('未就学') !== -1) {
      child.schoolYear = child.school_year.substr(0, 3)
    } else if (child.school_year.indexOf('高卒以上') !== -1) {
      child.schoolYear = child.school_year
    } else {
      child.schoolYear =
        child.school_year.substr(0, 1) + child.school_year.substr(2, 1)
    }
  })
  return allChildArray
}

export const schoolYearCahmelKeyConvert = (allChildArray: any[]) => {
  allChildArray.forEach((child: any) => {
    if (child.schoolYear.indexOf('歳') !== -1) {
      child.schoolYear = child.schoolYear.substr(0, 1)
    } else if (child.schoolYear.indexOf('未就学') !== -1) {
      child.schoolYear = child.schoolYear.substr(0, 3)
    } else if (child.schoolYear.indexOf('高卒以上') === -1) {
      child.schoolYear =
        child.schoolYear.substr(0, 1) + child.schoolYear.substr(2, 1)
    }
  })
  return allChildArray
}

export const handleMoveAffiliationItem = (affiliationArray: string[]) => {
  const tmpAffiliationArray = JSON.parse(JSON.stringify(affiliationArray))

  affiliationArray = tmpAffiliationArray
    .filter(
      (sortAffiliation: string) =>
        defineObject.JIHATSU_AFFILIATION === sortAffiliation
    )
    .concat(
      tmpAffiliationArray.filter(
        (sortAffiliation: string) =>
          defineObject.JIHATSU_AFFILIATION !== sortAffiliation &&
          defineObject.HOHOU_AFFILIATION !== sortAffiliation
      ),
      tmpAffiliationArray.filter(
        (sortAffiliation: string) =>
          defineObject.HOHOU_AFFILIATION === sortAffiliation
      )
    )

  return affiliationArray
}

export const sortInOrderOfAgeOfJihatsu = (allChildArray: any[]) => {
  const JIHATSU = '1'
  const AGE = '歳'
  const MISYUGAKU = '未就学'

  const jihatsuChildArray = allChildArray.filter((child: any) => {
    return child.affiliation.indexOf(JIHATSU) !== -1
  })

  const ageChildArray = jihatsuChildArray.filter((child: any) => {
    return child.school_year.indexOf(AGE) !== -1
  })
  const misyugakuChildArray = jihatsuChildArray.filter((child: any) => {
    return child.school_year.indexOf(MISYUGAKU) !== -1
  })

  ageChildArray.sort((a, b) => Number(a.schoolYear) - Number(b.schoolYear))
  const sortChildArray = ageChildArray.concat(misyugakuChildArray)

  const jihatsuActiveChildArray = sortChildArray.filter((child: any) => {
    return child.active === 1
  })
  const jihatsuNoActiveChildArray = sortChildArray.filter((child: any) => {
    return child.active === 0
  })
  allChildArray = jihatsuActiveChildArray.concat(jihatsuNoActiveChildArray)

  return allChildArray
}

export const sortInOrderOfSchoolYearOfHoday = (allChildArray: any[]) => {
  const HODAY = '0'
  const hodayChildArray = allChildArray.filter((child: any) => {
    return child.affiliation.indexOf(HODAY) !== -1
  })
  const KOSOTSU = '高卒以上'

  const ageChildArray = hodayChildArray.filter((child: any) => {
    return child.school_year.indexOf(KOSOTSU) === -1
  })

  const kosotsuChildArray = hodayChildArray.filter((child: any) => {
    return child.school_year.indexOf(KOSOTSU) !== -1
  })

  ageChildArray.sort(
    (a, b) => Number(a.schoolYear.substr(-1)) - Number(b.schoolYear.substr(-1))
  )

  const allSchoolChildArray = ageChildArray
    .filter(el => el.schoolYear.indexOf('小') > -1)
    .concat(
      ageChildArray.filter(el => el.schoolYear.indexOf('中') > -1),
      ageChildArray.filter(el => el.schoolYear.indexOf('高') > -1),
      kosotsuChildArray
    )

  const hodayActiveChildArray = allSchoolChildArray.filter((child: any) => {
    return child.active === 1
  })
  const hodayNoActiveChildArray = allSchoolChildArray.filter((child: any) => {
    return child.active === 0
  })

  allChildArray = hodayActiveChildArray.concat(hodayNoActiveChildArray)
  return allChildArray
}

export const sortInOrderOfSchoolYearOfVisit = (allChildArray: any[]) => {
  const AGE = '歳'
  const MISYUGAKU = '未就学'
  const KOSOTSU = '高卒以上'

  const ageChildArray = allChildArray.filter((child: any) => {
    return child.school_year.indexOf(AGE) !== -1
  })
  const misyugakuChildArray = allChildArray.filter((child: any) => {
    return child.school_year.indexOf(MISYUGAKU) !== -1
  })

  ageChildArray.sort((a, b) => Number(a.schoolYear) - Number(b.schoolYear))
  const sortChildArray = ageChildArray.concat(misyugakuChildArray)

  const jihatsuActiveChildArray = sortChildArray.filter((child: any) => {
    return child.active === 1
  })
  const jihatsuNoActiveChildArray = sortChildArray.filter((child: any) => {
    return child.active === 0
  })

  const syugakuChildArray = allChildArray.filter((child: any) => {
    return (
      child.school_year.indexOf(AGE) === -1 &&
      child.school_year.indexOf(KOSOTSU) === -1
    )
  })

  const kosotsuChildArray = allChildArray.filter((child: any) => {
    return child.school_year.indexOf(KOSOTSU) !== -1
  })

  syugakuChildArray.sort(
    (a, b) => Number(a.schoolYear.substr(-1)) - Number(b.schoolYear.substr(-1))
  )

  const allSchoolChildArray = syugakuChildArray
    .filter(el => el.schoolYear.indexOf('小') > -1)
    .concat(
      syugakuChildArray.filter(el => el.schoolYear.indexOf('中') > -1),
      syugakuChildArray.filter(el => el.schoolYear.indexOf('高') > -1),
      kosotsuChildArray
    )

  const hodayActiveChildArray = allSchoolChildArray.filter((child: any) => {
    return child.active === 1
  })
  const hodayNoActiveChildArray = allSchoolChildArray.filter((child: any) => {
    return child.active === 0
  })

  allChildArray = jihatsuActiveChildArray.concat(
    hodayActiveChildArray,
    jihatsuNoActiveChildArray,
    hodayNoActiveChildArray
  )
  return allChildArray
}

export const handleGetUniqueStr = (myStrong?: number): string => {
  let strong = 1000
  if (myStrong) strong = myStrong

  return (
    new Date().getTime().toString(16) +
    Math.floor(strong * Math.random()).toString(16)
  )
}

// 半角→全角(英数字)
export const replaceHalfToFull = function(str: string) {
  return str.replace(/[!-~]/g, function(s: string) {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
  })
}

export const convertKigoHanZen = (str: string, option: number) => {
  //option=0:半角から全角, 1:全角から半角
  let i, before, after
  if (option !== 0) {
    option = 1
  }

  const pairs = [
    ['\u0020', '\u3000'], // 半角スペース⇔全角スペース
    ['\u0021', '\uFF01'], // !⇔！
    ['\u0022', '\u201D'], // "⇔”
    ['\u0023', '\uFF03'], // #⇔＃
    ['\u0024', '\uFF04'], // $⇔＄
    ['\u0025', '\uFF05'], // %⇔％
    ['\u0026', '\uFF06'], // &⇔＆
    ['\u0027', '\u2019'], // '⇔’
    ['\u0028', '\uFF08'], // (⇔（
    ['\u0029', '\uFF09'], // )⇔）
    ['\u002A', '\uFF0A'], // *⇔＊
    ['\u002B', '\uFF0B'], // +⇔＋
    ['\u002C', '\uFF0C'], // ,⇔，
    ['\u002D', '\uFF0D'], // -⇔－
    ['\u002E', '\uFF0E'], // .⇔．
    ['\u002F', '\uFF0F'], // /⇔／
    ['\u003A', '\uFF1A'], // :⇔：
    ['\u003B', '\uFF1B'], // ;⇔；
    ['\u003C', '\uFF1C'], // <⇔＜
    ['\u003D', '\uFF1D'], // =⇔＝
    ['\u003E', '\uFF1E'], // >⇔＞
    ['\u003F', '\uFF1F'], // ?⇔？
    ['\u0040', '\uFF20'], // @⇔＠
    ['\u005B', '\uFF3B'], // [⇔［
    ['\u005C', '\uFFE5'], // \⇔￥
    ['\u005D', '\uFF3D'], // ]⇔］
    ['\u005E', '\uFF3E'], // ^⇔＾
    ['\u005F', '\uFF3F'], // _⇔＿
    ['\u0060', '\uFF40'], // `⇔｀
    ['\u007B', '\uFF5B'], // {⇔｛
    ['\u007C', '\uFF5C'], // |⇔｜
    ['\u007D', '\uFF5D'], // }⇔｝
    ['\u007E', '\uFF5E'], // ~⇔～
    ['\uFF61', '\u3002'], // ｡⇔。
    ['\uFF62', '\u300C'], // ｢⇔「
    ['\uFF63', '\u300D'], // ｣⇔」
    ['\uFF64', '\u3001'], // ､⇔、
    ['\uFF65', '\u30FB'], // ･⇔・
  ]
  const pairsLlength = pairs.length
  for (i = 0; i < pairsLlength; i++) {
    before = pairs[i][option]
    after = pairs[i][1 - option]
    while (str != str.replace(before, after)) {
      str = str.replace(before, after)
    }
  }
  return str
}

export const formatPostalCode = (postalCode: string | number | undefined) => {
  if (postalCode === undefined || postalCode === null || postalCode === '')
    return ''
  const digitsOnly = String(postalCode).replace(/\D/g, '')
  if (digitsOnly.length >= 7) {
    return digitsOnly.slice(0, 3) + '-' + digitsOnly.slice(3)
  }
  return digitsOnly
}
